import React, { useState } from "react";
import { Calendar } from "lucide-react";
import ConsultationModal from "./ConsultationModal";

/**
 * ConsultCtaBand — drop this on any page to satisfy the
 * "every page must have at least one in-page Consult CTA" rule.
 *
 * The cyan card is wrapped in the same `max-w-[1400px] mx-auto px-6 sm:px-8`
 * container the rest of the site uses, so the band lines up with surrounding
 * sections instead of bleeding wider than them.
 */
export default function ConsultCtaBand({
  source = "page-cta",
  headline = "Need expert eyes on your post-quantum readiness?",
  copy = "Book a free 30-minute consultation with the QorTrace team. We'll walk through your scan results and a migration roadmap — no commitment.",
  ctaLabel = "Schedule a Consult",
  variant = "band",
  className = "",
  testid = "page-consult-band",
  maxWidth = 1200,
}) {
  const [open, setOpen] = useState(false);
  const verticalMargin = variant === "card" ? "py-12" : "py-6";

  return (
    <>
      <div className={`mx-auto px-6 sm:px-8 ${verticalMargin}`} style={{ maxWidth }}>
        <section
          data-testid={testid}
          className={`qt-card ${className}`}
          style={{
            background: "#000000",
            border: "1px solid var(--qt-cyan)",
            padding: variant === "card" ? "2.5rem" : "1.75rem 2rem",
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
            <div className="md:col-span-8">
              <div className="qt-label" style={{ color: "var(--qt-cyan)" }}>SCHEDULE A CONSULT</div>
              <div className="qt-h2 text-xl sm:text-2xl mt-1" style={{ color: "#fff" }}>{headline}</div>
              <p className="mt-2 text-sm sm:text-base" style={{ color: "var(--qt-text-2)" }}>{copy}</p>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <button
                data-testid={`${testid}-cta`}
                onClick={() => setOpen(true)}
                className="qt-btn qt-btn-primary"
                style={{ padding: "0.85rem 1.25rem" }}
              >
                <Calendar size={16} /> {ctaLabel}
              </button>
            </div>
          </div>
        </section>
      </div>

      {open && (
        <ConsultationModal
          open={open}
          onClose={() => setOpen(false)}
          source={source}
        />
      )}
    </>
  );
}
